var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.report{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "report",
    d: "M12.25,1h-8.5C2.23,1,1,2.24,1,3.75v8.5C1,13.77,2.23,15,3.75,15h8.51c1.52,0,2.75-1.23,2.75-2.75v-8.5 C15,2.24,13.77,1,12.25,1z M13.5,12.25c0,0.69-0.56,1.25-1.25,1.25h-8.5c-0.69,0-1.25-0.56-1.25-1.25v-8.5 c0-0.69,0.56-1.25,1.25-1.25h8.49c0.69,0,1.25,0.56,1.25,1.25v8.5H13.5z M10.81,4h-5.5C4.89,4,4.56,4.34,4.56,4.75 S4.89,5.5,5.31,5.5h5.5c0.41,0,0.75-0.34,0.75-0.75S11.22,4,10.81,4z M10.81,10.5h-5.5c-0.41,0-0.75,0.34-0.75,0.75S4.89,12,5.31,12 h5.5c0.41,0,0.75-0.34,0.75-0.75S11.22,10.5,10.81,10.5z M10.81,7.24h-5.5c-0.41,0-0.75,0.34-0.75,0.75c0,0.41,0.34,0.75,0.75,0.75 h5.5c0.41,0,0.75-0.34,0.75-0.75C11.56,7.58,11.22,7.24,10.81,7.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReport);
export default __webpack_public_path__ + "static/media/icon_report.5c2eb961688e2c1f08cbd8bbcd24c0dc.svg";
export { ForwardRef as ReactComponent };